import { render, staticRenderFns } from "./fileImg.vue?vue&type=template&id=1c5612ea&scoped=true"
import script from "./fileImg.vue?vue&type=script&lang=js"
export * from "./fileImg.vue?vue&type=script&lang=js"
import style0 from "./fileImg.vue?vue&type=style&index=0&id=1c5612ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5612ea",
  null
  
)

export default component.exports